import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ServicesComponent } from './services/services.component';
import { HousesRouterComponent } from './houses/houses-router.component';
import { HousesComponent } from './houses/houses.component';
import { PartnersComponent } from './partners/partners.component';
import { HouseDetailsComponent } from './houses/house-details.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ProjectDetailsComponent } from './portfolio/project-details.component';
import { ContactComponent } from './contact/contact.component';

import { PropertyService } from './common-theme/api/property.service';
import { ProjectService } from './common-theme/api/project.service';
import { ReasonService } from './common-theme/api/reason.service';
import { AgentService } from './common-theme/api/agent.service';
import { WebPageService } from './common-theme/api/web-page.service';
import { PartnerService } from './common-theme/api/partner.service';
import { ServiceService } from './common-theme/api/service.service';
import { AdvancedLimitsService } from './common-theme/api/advanced-limits.service';

const app_routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      projectSearch: {
        sale_status: 'available'
      }
    },
    resolve: {
      projects: ProjectService,
      reasons: ReasonService
    }
  },
  {
    path: 'despre-noi',
    component: AboutUsComponent,
    data: { page_type: 'about_us' },
    resolve: {
      agents: AgentService,
      web_page: WebPageService
    }
  },
  {
    path: 'parteneri',
    component: PartnersComponent,
    resolve: {
      partners: PartnerService
    }
  },
  {
    path: 'servicii',
    component: ServicesComponent,
    resolve: {
      services: ServiceService,
      reasons: ReasonService
    }
  },
  {
    path: 'apartamente',
    component: HousesComponent,
    data: { property_type: 'apartamente' },
    resolve: {
      properties: PropertyService,
      advanced_limits: AdvancedLimitsService,
      projects: ProjectService
    }
  },
  {
    path: 'apartamente/:friendly_id',
    component: HouseDetailsComponent,
    resolve: { property: PropertyService }
  },
  {
    path: 'portofoliu',
    component: HousesRouterComponent,
    children: [
      {
        path: '',
        component: PortfolioComponent,
        resolve: { projects: ProjectService }
      },
      {
        path: ':id',
        component: ProjectDetailsComponent,
        resolve: { project: ProjectService }
      }
    ]
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];
export const app_routing = RouterModule.forRoot(app_routes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts